import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import $ from 'jquery';
import {number_format,number_input_format} from '../helper/format';

class Paypopup extends Component {
  constructor(props)
  {
    super(props);
    this.state = {
      open : false,
      installment_price : 0,
      pay_price : 0
    };

    this.priceTextObj = null;
  }
  Open(_installment_price, _pay_price)
  {
    this.setState({
      open: true,
      pay_price : _pay_price,
      installment_price : _installment_price
    });
  }
  Close()
  {
    this.setState({
      open: false
    });
  }
  ChangePrice()
  {
      if( this.priceTextObj )
      {
        this.setState ( {pay_price: this.priceTextObj.value} );
      }
  }
  Apply()
  {
    this.props.onPayChanged(this.state.pay_price);
    this.setState({
      open: false
    });
  }
  render()
  {
    const self = this;
    return (
        <Modal open={this.state.open} onClose={()=>{self.Close()}} center>
          <div className="modal-dialog modal-md mb0">
            <div className="popupPadding2 pr45">
              <div className="md-popup-header"> &nbsp;현금 납부액 입력</div>
              <div className="md-popup-contents">
                <div>할부 원금 : {number_input_format(self.state.installment_price)} 원</div>
                <div className="pt15">
                  <div className="row">
                    <div className="col-xs-11">
                      <input type="number" ref={(ref)=>{this.priceTextObj = ref}} className="form-control" onChange={()=>{self.ChangePrice()}} value={this.state.pay_price}/>
                    </div>
                    <div className="col-xs-1 font18 pl0 pt10">
                      원
                    </div>
                  </div>
                </div>
                <div className="pt20 pl18">
                  <div className="row font16">
                    ※ 할부원금을 초과한 금액은 적용하실 수 없습니다.
                  </div>
                  <div className="row font16">
                    입력한 현금납부액을 적용하시겠습니까?
                  </div>
                </div>
                <div className="pt40">
                  <div className="row text-center">
                    <a href="#applyPrice" onClick={()=>{self.Apply()}} className="btn btn-bar btn-lg btn-select2">확인</a>&nbsp;&nbsp;&nbsp;&nbsp;
                    <a href="#cancel" onClick={()=>{self.Close()}} className="btn btn-cancel btn-lg btn-select2">취소</a>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </Modal>
    );
  }
}

export default Paypopup;
